<div class="flex">
  <div
    class="py-1 px-2 flex items-center border rounded-full text-white {{
      bgClasses
    }}"
  >
    <ark-icon [icon]="icon" [color]="iconColor" [size]="iconSize"> </ark-icon>
    <span class="ml-2">{{ label }}</span>
  </div>
</div>
